module.exports = __webpack_public_path__ + "media/Painting960.67d2d9f7.mp4";